import React from 'react';
import _ from 'lodash'
import PropTypes from 'prop-types'

import './ToolDetailBody.sass'


function renderTags(tags) {
  return tags.map((tag, idx) =>
    <span key={idx} className="tag">{tag}</span>
  )
}

function renderEntries(entries) {
  return entries.map((entry, idx) =>
    <div key={idx} className="case-study">
      <h4 className="case-study-title">{entry.title}</h4>
      <a
        href={entry.url}
        rel="noopener noreferrer"
        target="_blank"
        className="btn-blue-transparent-sm"
      >
        view
      </a>
    </div>
  )
}

function renderFiltersToDisplay(filters) {
  // lodash map over object to get filter keys (names) and their values to render data dynamically
  return _.map(filters, (filterVal, filterName) =>
    <div className="tool-detail-section" key={filterName}>
      <h4 className="tool-detail-section-header">{filterName}</h4>
      <ul className="bullet-list">
        {filterVal.map((val, idx) => <li key={idx}>{val}</li>)}
      </ul>
    </div>
  )
}

function renderCaseStudiesOrPublications(caseStudies, publications) {
  // Return nothing if there are no case studies or publications
  const hasCaseStudies = caseStudies && caseStudies.length
  const hasPublications = publications && publications.length

  if (!hasCaseStudies && !hasPublications) {
    return null
  }

  return (
    <div className="tool-detail-section case-studies-section">
      <h4 className="tool-detail-section-header">{ hasCaseStudies ? 'Case Studies' : 'Publications' }</h4>
      { hasCaseStudies ? renderEntries(caseStudies) : renderEntries(publications) }
    </div>
  )
}

function renderDetails(tool) {
  // Remove falsey key/values from object (e.g. "primary_name: null")
  const contactInfo = _.pickBy(tool.contact_info, _.identity)

  return (
    <div className="details-section">

      <div className="tool-detail-section">
        <h4 className="tool-detail-section-header">Strengths</h4>
        {tool.strengths ?
          <div className="markdown-bullet-list" dangerouslySetInnerHTML={{__html: tool.strengths}} /> :
          <p>Not specified</p>
        }
      </div>

      <div className="tool-detail-section">
        <h4 className="tool-detail-section-header">Limitations</h4>
        {tool.limitations ?
          <div className="markdown-bullet-list" dangerouslySetInnerHTML={{__html: tool.limitations}} /> :
          <p>Not specified</p>
        }
      </div>

      <div className="tool-detail-section">
        <h4 className="tool-detail-section-header">Target Audience</h4>
        <p>{tool.target_audience ? tool.target_audience : 'Not specified'}</p>
      </div>

      {tool.filters_to_display && renderFiltersToDisplay(tool.filters_to_display)}

      <div className="tool-detail-section">
        <h4 className="tool-detail-section-header">Contact</h4>
          { !_.isEmpty(contactInfo) ?
            <React.Fragment>
              {contactInfo.contact_url &&
                <div className="entry">
                  <p><a href={contactInfo.contact_url} rel="noopener noreferrer" target="_blank">Contact form</a></p>
                </div>
              }
              <div className="entry">
                <p>{contactInfo.primary_name}</p>
                { contactInfo.primary_email &&
                  <p><a href={`mailto:${contactInfo.primary_email}`} rel="noopener noreferrer" target="_top">{contactInfo.primary_email}</a></p>
                }
              </div>
              <div className="entry">
                <p>{contactInfo.secondary_name}</p>
                { contactInfo.secondary_email &&
                  <p><a href={`mailto:${contactInfo.secondary_email}`} rel="noopener noreferrer" target="_top">{contactInfo.secondary_email}</a></p>
                }
              </div>
            </React.Fragment> :
            <p>Not specified</p>
          }
      </div>
    </div>
  )
}

const ToolDetailBody = ({ tool }) => {
  return (
    <section className="tool-detail-body">
      <div className="tool-detail-section tags-section">
        <h4 className="tool-detail-section-header">Tags</h4>
        { (tool.tags && tool.tags.length) ?
          <div className="tags">{renderTags(tool.tags)}</div> :
          <p>None</p>
        }
      </div>
      {renderDetails(tool)}
      {renderCaseStudiesOrPublications(tool.case_studies, tool.publications)}
    </section>
  )
}

ToolDetailBody.propTypes = {
  tool: PropTypes.object
}

export default ToolDetailBody
